<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="pl-2">
      <v-icon class="flex-grow-0 pr-4">
        groups
      </v-icon>
      <span>Family Overview</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row
        v-for="(item, index) of summaryItems"
        :key="index"
        class="text-caption"
      >
        <v-col>{{ item.text }}</v-col>
        <v-col>{{ item.value }}</v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { PARTY_NAMESPACE } from '@/store/party'
import { humanize } from '@/utilities/string-utilities'
import { mapGetters } from 'vuex'

export default {
  name: 'FamilyOverviewSummary',

  data () {
    return {
      items: [
        { prop: 'num_marriages', value: null },
        { prop: 'currently_married', value: null },
        { prop: 'num_children', value: null },
        { prop: 'num_siblings', value: null },
        { prop: 'mother_status', value: null },
        { prop: 'father_status', value: null },
        { prop: 'usc_siblings', value: null },
        { prop: 'lpr_siblings', value: null },
      ],
    }
  },

  computed: {
    summaryItems () {
      return this.items.map(item => ({ ...item, text: humanize(item.prop), value: this.peParty[item.prop] }))
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },
}
</script>
